const SET_USER_FAVORITE_BRANDS = 'SET_USER_FAVORITE_BRANDS';

export { SET_USER_FAVORITE_BRANDS };
